import Action, { UserDataActions } from "@my-dld/actions";
import { AnyAction } from "redux";
import { AssetCard, ProxyAsset } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { Lease } from "@eres/ejari-api/Entity";
import _ from "lodash";
import { IUser } from "@10x/sso";
import { Property } from "@my-dld/screens/MyDLD/Portfolio/MollakMeydaanAPI/entities";

export interface UserDataState {
	properties?: AssetCard[];
	mapProperties?: Property[];
	mapPropertiesLoading?: boolean;
	proxyProperties?: ProxyAsset[];
	propertyLoading?: boolean;
	leases?: Lease[];
	leaseLoading?: boolean;
	assetVersion: number;
	leaseVersion: number;
}

export const defaultState: UserDataState = {
	properties: undefined,
	leases: undefined,
	assetVersion: 0,
	leaseVersion: 0,
};

function nextVersion( current: number ) {
	// 2020 bad no go
	if ( current === 2019 )
		return 1;
	return current + 1;
}

export function UserDataReducer( state = defaultState, action: AnyAction ): UserDataState {
	switch ( action.type ) {
		case Action.USER_LOGGED_IN:
			const newUser = action.payload;
			const oldUser = action.oldUser;
			if ( !checkIsSameUser( oldUser, newUser ) ) {
				return {
					assetVersion: 0,
					leaseVersion: 0,
					properties: undefined,
					leases: undefined,
					mapProperties: undefined,
				};
			}
			return state;
		case Action.USER_LOGGED_OUT:
			return {
				assetVersion: 0,
				leaseVersion: 0,
				properties: undefined,
				leases: undefined,
				mapProperties: undefined,
			};
		case UserDataActions.ON_PROPERTIES:
			return {
				...state,
				properties: action.payload.owned,
				proxyProperties: action.payload.companyProperties,
				propertyLoading: false,
				assetVersion: nextVersion( state.assetVersion ),
			};
		case UserDataActions.ON_LEASE:
			return {
				...state,
				leases: action.payload,
				leaseLoading: false,
				leaseVersion: nextVersion( state.leaseVersion ),
			};
		case UserDataActions.ON_PROPERTIES_LOADING:
			return {
				...state,
				propertyLoading: true,
			};
		case UserDataActions.ON_LEASE_LOADING:
			return {
				...state,
				leaseLoading: true,
			};
		case UserDataActions.ON_MAP_PROPERTIES:
			return {
				...state,
				mapProperties: action.payload,
				mapPropertiesLoading: false,
			};
		case UserDataActions.ON_MAP_PROPERTIES_LOADING:
			return {
				...state,
				mapPropertiesLoading: true,
			};
		default:
			return state;
	}
}

function checkIsSameUser( oldUser: IUser, newUser: IUser ): boolean {
	if ( oldUser === newUser )
		return true;
	if ( _.isEqual( oldUser, newUser ) )
		return true;
	if ( oldUser == null || newUser == null ) {
		return false;
	}
	if ( oldUser && newUser ) {
		const profiles = oldUser.profiles;
		const newProfiles = newUser.profiles;
		for ( const profile of profiles ) {
			const np = newProfiles.find( x => x.source === profile.source );
			if ( !np )
				return false;
			if ( profile.id != np.id )
				return false;
		}
		return true;
	}
	return false;
}
